import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { companyAPI } from '../utils/api';

const MarketingNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    companyAPI.getInfo().then((res) => setCompanyInfo(res.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3">
            <img src={companyInfo?.logo_url || '/ecoway-logo.jpeg'} alt={`${companyInfo?.company_name || 'Ecoway Cabs'} Logo`} className="h-12 w-12 object-contain" />
            <span className="text-2xl font-bold text-gray-900">{companyInfo?.company_name || 'Ecoway Cabs'}</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors">Home</Link>
            <Link to="/services" className="text-gray-700 hover:text-blue-600 transition-colors">Services</Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors">About Us</Link>
            <Link to="/cities" className="text-gray-700 hover:text-blue-600 transition-colors">Cities</Link>
            <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition-colors">Contact</Link>
            <Button asChild><Link to="/quote">Get Quote</Link></Button>
          </div>

          <button 
            className="md:hidden p-2" 
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle mobile menu"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-blue-600" onClick={() => setIsOpen(false)}>Home</Link>
              <Link to="/services" className="text-gray-700 hover:text-blue-600" onClick={() => setIsOpen(false)}>Services</Link>
              <Link to="/about" className="text-gray-700 hover:text-blue-600" onClick={() => setIsOpen(false)}>About Us</Link>
              <Link to="/cities" className="text-gray-700 hover:text-blue-600" onClick={() => setIsOpen(false)}>Cities</Link>
              <Link to="/contact" className="text-gray-700 hover:text-blue-600" onClick={() => setIsOpen(false)}>Contact</Link>
              <Button asChild className="w-full"><Link to="/quote" onClick={() => setIsOpen(false)}>Get Quote</Link></Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default MarketingNavbar;